/* eslint-disable max-len */
import React from "react"
import BaseSvgIcon from "./Base"

const MyRecognition = (props) => {
  return (
    <BaseSvgIcon viewBox="0 0 24 24" {...props}>
      <path
        fill="#3D3D36"
        d="M19.1,6.2c-1-1-2.4-1.6-3.9-1.6c-1.3,0-2.4,0.4-3.4,1.2c-1-0.8-2.1-1.2-3.4-1.2C7,4.6,5.6,5.2,4.6,6.2
          c-2.1,2.1-2.1,5.5,0,7.6l0.3,0.3l5.9,5.9c0.3,0.3,0.6,0.4,1,0.4c0.4,0,0.8-0.2,1-0.4l6.2-6.2C21.2,11.7,21.2,8.3,19.1,6.2z
          M18,12.8L11.8,19l-5.9-5.9l-0.3-0.3C4,11.2,4,8.7,5.6,7.2C6.4,6.4,7.4,6,8.4,6s2,0.4,2.8,1.2c0.2,0.2,0.4,0.5,0.6,0.7
          c0.2-0.3,0.4-0.5,0.6-0.7C13.2,6.4,14.2,6,15.2,6s2,0.4,2.8,1.2C19.6,8.7,19.6,11.2,18,12.8z M6.9,8.4c-0.9,0.8-0.9,2.2,0,3
          c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.5-0.2c0.3-0.3,0.3-0.7,0-1c-0.3-0.3-0.3-0.7,0-1c0.3-0.3,0.7-0.3,1,0
          c0.3,0.3,0.7,0.3,1,0c0.3-0.3,0.3-0.7,0-1C9.1,7.6,7.8,7.6,6.9,8.4z"
      />
    </BaseSvgIcon>
  )
}

export default MyRecognition
